import React, { useState, useContext, useEffect, useRef, useCallback } from "react";
import { useSpring, animated } from "react-spring";
import { useLocation, useParams } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import { Editor, EditorState, convertFromRaw } from "draft-js";
import axios from "axios";

import { Info } from "react-feather";

import { getQueryParam, useScreenTransition } from "../../Hooks/useScreenTransition";

import { TransitionContext } from "../../Context/TransitionContext";
import { NotificationContext } from "../../Context/NotificationContext";
import { DataContext } from "../../Context/DataContext";
import { AuthContext } from "../../Context/AuthContext";

import { languages } from "../../Data/languages";
import { ReactComponent as QUOTESUCCESS } from "../../assets/icons/quote-success.svg";

import AccountNavBar from "../../NewComponents/AccountNavBar";
import { ReactComponent as CHECK } from "../../assets/icons/CheckmarkСircleFill.svg";
import SecureAndPrivate from "../../NewComponents/SecureAndPrivate";
import { QUOTESTATUS } from "../../Data/statuses";
import OrderSummary from "../Order/components/OrderSummary";

import { ReactComponent as DOWNLOAD } from "../../assets/icons/Download.svg";
import SendPaymentLinkPopUp from "../../NewComponents/SendPaymentLinkPopUp";
import PopUpModal from "../../NewComponents/PopUpModal";
import "./SingleQuote.css";
import NoData from "../../NewComponents/NoData";
import { getBlob } from "@firebase/storage";
import { saveAs } from "file-saver";
import { decrTeamFreeExpedOrder, formatTotal, getDiscount, getExpedited, getTotal, updateInvoiceClientName } from "../../Data/Functions";
import AddCommentonDocument from "../../NewComponents/AddComment/AddCommentonDocument";
import { auth, firestore, getFullHttpUrl, storage } from "../../firebase.config";
import { useReactToPrint } from "react-to-print";
import { QuoteSummaryToPrint } from "../../Components/QuoteSummaryToPrint";
import { getCounter } from "../../Data/Functions/getCounter";
import { AccountType } from "../../utility/enums";
import MessageDot from "../../NewComponents/MessageDot";
import OrderChatBox from "../../Components/OrderChatBox";
import Loader from "../../NewComponents/Loader";
import { FormTextInput } from "../../Components/FormTextInput";
import NewButton from "../../NewComponents/NewButton";
import OpenInvoiceModal from "../../NewComponents/OpenInvoiceModal";
import { sampleQuotesData } from "./QuotesComponent";
import SignInForm from '../SignIn/SignInForm.js';
import CreateAccount from '../CreateAccount/CreateAccount.js';
import GetFileTypeElement from "../../Data/Functions/getFileType.js";

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

const SingleQuote = ({ windowSize }) => {
  const { transitionTo } = useScreenTransition();

  const { setColor } = useContext(TransitionContext);

  const { showNotification } = useContext(NotificationContext);

  const { userData, teamData } = useContext(DataContext);

  const { signedIn } = useContext(AuthContext);

  useEffect(() => {
    setColor(true);
  }, [setColor]);

  // useEffect(() => {
  //     if(!signedIn || (userData && userData.role === "client")){
  //       return transitionTo("/");
  //     }
  //   }, [signedIn, userData]);

    const redirect_status = getQueryParam("redirect_status");
    
        useEffect(() => {
          if(redirect_status){
            if(redirect_status === "succeeded"){
            showNotification("Success", "Payment paid successfully.", "sucess")
            }else{
              showNotification("Error", "Payment failed, please try again.", "error")
            }
          }
        }, redirect_status)

  const { quoteID } = useParams();

  const [selectedSendPayment, setSelectedSendPayment] = useState("");
  const [quoteInfo, setQuoteInfo] = useState(null);
  const [loadedQuote, setLoadedQuote] = useState(false);

  const [selectedPayment, setSelectedPayment] = useState("");
  const [paylaterBtn, setPaylaterBtn] = useState("Pay Later");
  const [cancelBtnText] = useState("Cancel Quote");

  const [isLoading, setIsLoading] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState("");
  const [showStatusHoverBox, setShowStatusHoverBox] = useState(false);

  const [saveClientBtnTxt, setSaveClientBtnTxt] = useState("Save");

  const [clientFirstName, setClientFirstName] = useState("");
  const [clientLastName, setClientLastName] = useState("");

  const [openInvoiceModal, setOpenInvoiceModal] = useState("");

  const [editorState, setEditorState] = React.useState(() =>
    EditorState.createEmpty()
  );

  const [quoteUpdated, setQuoteUpdated] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0);


  const [isModalOpen, setIsModalOpen]=useState(false);
  const [isCreateAccountOpen, setIsCreateAccountOpen]=useState(false);

  useEffect(() => {

    if(quoteID === "1234567890"){
      setQuoteInfo(sampleQuotesData[0]);
      setLoadedQuote(true);
      return;
    }
    if(quoteID === "1234567891"){
      setQuoteInfo(sampleQuotesData[1]);
      setLoadedQuote(true);
      return;
    }
    if(quoteID === "1234567892"){
      setQuoteInfo(sampleQuotesData[2]);
      setLoadedQuote(true);
      return;
    }


   const unSub = firestore
      .collection("quotes")
      .doc(quoteID)
      .onSnapshot((doc) => {
        if (doc.exists) {
          const quoteData = doc.data();
          setQuoteInfo({ ...quoteData, id: doc.id });

          if (doc.data().teamId && doc.data().clientFirstName) {
              setClientFirstName(doc.data().clientFirstName);
              setClientLastName(doc.data().clientLastName);
            }

          if (
            quoteData.notes &&
            typeof quoteData.notes === "object" &&
            quoteData.notes.blocks
          ) {
            setEditorState(
              EditorState.createWithContent(convertFromRaw(quoteData.notes))
            );
          } else {
            console.warn("Notes field is missing or not in correct format.");
            setEditorState(EditorState.createEmpty());
          }

          setLoadedQuote(true);

          sleep(500).then(() => {
            if (
              (windowSize.width > 767 ||
                windowSize.orientation === "landscape") &&
              document.getElementById("mainPrimary") &&
              document.getElementById("mainSecondary")
            ) {
              if (
                document.getElementById("mainPrimary").clientHeight >
                document.getElementById("mainSecondary").clientHeight
              ) {
                document.getElementById("mainSecondary").style.height = `${
                  document.getElementById("mainPrimary").clientHeight
                }px`;
              } else {
                document.getElementById("mainPrimary").style.height = `${
                  document.getElementById("mainSecondary").clientHeight
                }px`;
              }
            }
          });
        } else {
          transitionTo("/");
          // showNotification(
          //   "Error",
          //   "An error ocurred loading the quote info. Try again. If it persists, please contact Support.",
          //   "error"
          // );
        }
      })

      return () => unSub();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quoteID, quoteUpdated]);

  const formatDate = (timestamp) => {
    if (String(timestamp).length === 10) {
      timestamp *= 1000;
    }

    const date = new Date(timestamp);

    const options = { month: "short", day: "2-digit", year: "numeric" };
    const formattedDate = date.toLocaleDateString("en-US", options);

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";

    hours = hours % 12 || 12;

    return `${formattedDate} @${String(hours).padStart(
      2,
      "0"
    )}:${minutes} ${ampm}`;
  };

  const getLanguage = (language) => {
    if (languages.find((lang) => lang.value === language)) {
      return languages.find((lang) => lang.value === language).label;
    } else {
      return "";
    }
  };

  const downloadFile = url => {
    window.open(url, '_blank')
}

  const handlePlaceOrder = async (quoteInfo, paypalID) => {
    setPaylaterBtn("Placing Order...");
    setIsLoading(true);

    const now = new Date();


    let orderNumber = 0;

    await getCounter("order").then((number) => {
        orderNumber = parseInt(number, 10);
      })
    .catch((error) => {});

    if (orderNumber === 0) {
      showNotification(
        "Error",
        "An error ocurred while placing the order. Please, try again. If it persists, contact support.",
        "error"
      );
      setPaylaterBtn("Pay Later");
      return false;
    }

    // const addressID = uuidv4();
    const orderID = uuidv4();

    const hardCopyAddress = quoteInfo.hardCopy && quoteInfo.hardCopyExtra;

    const saveNewAddress =
      hardCopyAddress &&
      hardCopyAddress.newAddress &&
      hardCopyAddress.saveAddress;

    const address = hardCopyAddress.newAddress
      ? {
          id: hardCopyAddress.id,
          country: hardCopyAddress.country,
          addressName: hardCopyAddress.addressName,
          firstName: hardCopyAddress.firstName,
          lastName: hardCopyAddress.lastName,
          recipient: hardCopyAddress.firstName + " " + hardCopyAddress.lastName,
          region: hardCopyAddress.region,
          city: hardCopyAddress.city,
          zipCode: hardCopyAddress.zipCode,
          street: hardCopyAddress.street,
          apartment: hardCopyAddress.apartment,
        }
      : signedIn &&
        userData &&
        userData.shipping &&
        userData.shipping.length > 0 &&
        userData.shipping.find((a) => a.id === hardCopyAddress.id);

    const saveNewAddressData = saveNewAddress ? address : "";

    firestore
      .collection("orders")
      .doc(orderID)
      .set({
        orderNumber: orderNumber,
        userID: quoteInfo.userID,
        email: quoteInfo.email,
        name: quoteInfo.name,
        certified: quoteInfo.certified,
        languageFrom: quoteInfo.languageFrom,
        languageTo: quoteInfo.languageTo,
        notarization: quoteInfo.notarization,
        notarizationStatus: quoteInfo.notarization ? "pending" : null,
        expedited: quoteInfo.expedited,
        hardCopy: quoteInfo.hardCopy,
        hardCopyStatus: quoteInfo.hardCopy ? "pending" : null,
        hardCopyExtra:
          quoteInfo.hardCopy && quoteInfo.hardCopyExtra
            ? quoteInfo.hardCopyExtra
            : null,
        pagesCount: quoteInfo.certified ? quoteInfo.pagesCount : 0,
        wordCount: !quoteInfo.certified ? quoteInfo.wordCount : 0,
        notes: quoteInfo.notes,
        files: quoteInfo.files,
        timestamp: now.getTime(),
        status: "new",
        shippingInfo: hardCopyAddress ? address : null,
        paypalOrderID: paypalID,
        discountApplied: quoteInfo.discount && quoteInfo.discount > 0,
        discount:
          quoteInfo.discount && quoteInfo.discount > 0 ? quoteInfo.discount : 0,
        teamId: quoteInfo.teamId ?? "",
        totalPrice: getTotal(quoteInfo),
        expeditedServiceOption: quoteInfo.expeditedServiceOption,
        clientFirstName: quoteInfo.clientFirstName ?? "",
        clientLastName: quoteInfo.clientLastName ?? "",
        type: quoteInfo.teamId ? "business" : "personal",
        discountCode: quoteInfo.discountCode || "",
        translatorCertification: quoteInfo.translatorCertification || "",
        howDidYouHear: quoteInfo.howDidYouHear || "",
      })
      .then(async () => {
        await firestore.collection("quotes").doc(quoteInfo.id).update({
          status: "ordered",
          orderNumber: orderNumber,
          orderID: orderID,
        });
        if (signedIn && userData && saveNewAddress) {
          handleSaveNewAddress(saveNewAddressData);
        }

        if(quoteInfo.expedited || quoteInfo.expeditedPlus){
          decrTeamFreeExpedOrder(quoteInfo.teamId);
        }

        setPaylaterBtn("Pay Later");
        setIsLoading(false);
        setSelectedPayment("");
        setShowSuccessModal(quoteInfo.id);
        setQuoteUpdated((q) => !q);
      })
      .catch((error) => {
        //console.log(error);
        setIsLoading(false);
        setPaylaterBtn("Pay Later");
        showNotification(
          "Error",
          "An error ocurred while placing the order. Please, try again.",
          "error"
        );
      });
  };

  const handleSaveNewAddress = async (address) => {
    if (address) {

      const newAddress = { default: false, ...address };

      const mShipping = userData.shipping
        ? userData.shipping.concat([newAddress])
        : [newAddress];

      await firestore
        .collection("users")
        .doc(auth.currentUser.uid)
        .update({
          shipping: mShipping,
        })
        .then(() => {})
        .catch((error) => {
          showNotification(
            "Error",
            "An error ocurred while saving the address. Unfortunately, the address couldn't be saved.",
            "error"
          );
        });
    }
  };

  const getFullAddress = (address) => {
    const parts = [
      address.firstName && address.firstName !== "Undefined"
        ? address.firstName || address.recipient
        : "",
      address.lastName && address.lastName !== "Undefined"
        ? address.lastName
        : "",
      address.country && address.country !== "Undefined" ? address.country : "",
      address.region && address.region !== "Undefined" ? address.region : "",
      address.city && address.city !== "Undefined" ? address.city : "",
      address.zipCode && address.zipCode !== "Undefined" ? address.zipCode : "",
      address.street && address.street !== "Undefined" ? address.street : "",
      address.apartment && address.apartment !== "Undefined"
        ? address.apartment
        : "",
    ].filter(Boolean);

    return parts.join(", ");
  };

  const handlePay = (quote) => {
    if (userData && userData.teamId && teamData) {
      if (teamData.billingTerm && teamData.billingTerm !== "case-by-case") {
        handlePlaceOrder(quote, "auto-billing");
      } else {
        setSelectedPayment(quote);
      }
    } else {
      transitionTo(`/make-payment/quote/${quote.id}`);
    }
  };

  const handlePopUpClick = (e) => {
    if (signedIn) {
      // transitionTo(`/account/quote/${showSuccessModal}`, e);
      return setShowSuccessModal("");
    } else {
      // transitionTo("/", e);
      return setShowSuccessModal("");
    }
  };
  const statusOverlayProps = useSpring({
    display: isLoading ? "flex" : "none",
  });

 
  const [addCommentFile, setAddCommentFile] = useState(null);

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `Quote-#${quoteInfo && quoteInfo.quoteNumber}`,
  });


     const handleClick = () => {
          const data = {
              type : "newQuote",
              email: "rajatbedi23@gmail.com",
              param : {},
              number: 12345,
              data: quoteInfo,
              ccEmails: [],
          }
          axios.post(getFullHttpUrl("testingEmails"), data).then(() => alert("done"))
          // axios.post(getFullHttpUrl("teamInvoices-scheduledAutoTeamInvoices")).then(() => alert("done"))
        }

  const handleSaveClientName = async () => {
    if (clientFirstName === "") {
      showNotification(
        "Error",
        "Empty Client Name, please enter a client name.",
        "error"
      );
      return;
    }
    setSaveClientBtnTxt("Saving...");

    firestore
      .collection("quotes")
      .doc(quoteInfo.id)
      .update({
        clientFirstName: clientFirstName,
        clientLastName: clientLastName,
      })
      .then(async() => {
        // updateClientsName();
      })
      .catch((error) => {
        showNotification(
          "Error",
          "An error ocurred while saving client name. Please, try again.",
          "error"
        );
        setSaveClientBtnTxt("Save");
      })
      .finally(() => {
        setSaveClientBtnTxt("Save");
      });
  };

  const handleDownloadSummary = () => {
    setOpenInvoiceModal(quoteInfo);
  }

  const checkExpeditedServiceOption = useCallback(async (quoteTeamData, currentQuoteInfo) => {
    if(quoteTeamData && quoteTeamData.isCreatedByMarketingCampaign){
        const expeditedServiceOption = quoteTeamData.expeditedServices || "paid";
        if (currentQuoteInfo?.expeditedServiceOption !== expeditedServiceOption) {
            setQuoteInfo(prev => ({...prev, expeditedServiceOption}));
        }
    }
  }, []);

  const [quoteTeamData, setQuoteTeamData] = useState(null);

  useEffect(() => {
    if(quoteInfo && quoteInfo.teamId){
      const unsubscribe = firestore.collection("teams").doc(quoteInfo.teamId).onSnapshot((doc) => {
        if(doc.exists){
          setQuoteTeamData(doc.data());
        }
      });

      return () => unsubscribe();
    }
  }, [quoteInfo?.teamId]);

  useEffect(() => {
    if(quoteTeamData && quoteInfo){
      checkExpeditedServiceOption(quoteTeamData, quoteInfo);
    }
  }, [quoteTeamData, quoteInfo, checkExpeditedServiceOption]);

  const handleLoginOpen=(newState)=>{
    setIsModalOpen(newState);
  }

  const handleCreateAccountOpen=(newState)=>{
    setIsCreateAccountOpen(newState);
  }

  if (!loadedQuote) {
      return (
        <div className="container mx-auto w-full h-dvh flex items-center justify-center">
          <Loader />
        </div>
      );
    }

  return (
    <>
      {/* <button onClick={handleClick}>Send Email</button> */}

      <SignInForm
          open={isModalOpen}
          isLoginFormOpen={handleLoginOpen}
          isCreateAccountOpen={handleCreateAccountOpen}
          pageRedirect={false}
      />
      <CreateAccount
          open={isCreateAccountOpen}
          isCreateAccountOpen={handleCreateAccountOpen}
          isLoginFormOpen={handleLoginOpen}
      />

    {openInvoiceModal && <OpenInvoiceModal type="quote" order={openInvoiceModal} onClose={() => setOpenInvoiceModal(null)}/>}


      {addCommentFile ? (
        <AddCommentonDocument
          selectedFile={addCommentFile}
          orderInfo={quoteInfo}
          handleClose={() => setAddCommentFile(null)}
        />
      ) : (
        <>
          <animated.div
            style={statusOverlayProps}
            className="checkoutStatusOverlay"
          >
            We are finishing up. Please wait, this will take a second<span className="dotsLoading">...</span>
          </animated.div>
          {showSuccessModal && (
            <PopUpModal
              title="Quota has been converted into the order"
              btnText="Ok"
              onClick={(e) => handlePopUpClick(e)}
              text="You can track the status of the order on the orders page in your account"
            >
              {<QUOTESUCCESS />}
            </PopUpModal>
          )}

          {selectedSendPayment !== "" && (
            <SendPaymentLinkPopUp
              data={selectedSendPayment}
              type="quote"
              id={selectedSendPayment.id}
              onClose={() => setSelectedSendPayment("")}
            />
          )}
          {selectedPayment && (
            <PopUpModal
              title={"Create Order From The Quote"}
              backBtnText={paylaterBtn}
              subText={"Quote Number: #"+selectedPayment.quoteNumber}
              text={"Do you want to pay for the newly created order now or later?"}
              btnText={"Pay Now"}
              hideIcon
              showClose
              onClose={() => setSelectedPayment("")}
              onClick={(e) =>
                transitionTo(`/make-payment/quote/${selectedPayment.id}`, e)
              }
              onBackClick={() => {
                handlePlaceOrder(selectedPayment, "pay-later");
              }}
              disableBtn={paylaterBtn === "Paying..."}
            ></PopUpModal>
          )}

          <AccountNavBar
            windowSize={windowSize}
            selectedTab={"quotes"}
            accountMainPadding={false}
            bgTransparent={true}
            breadLink={`Quote #${
              quoteInfo ? (quoteInfo.quoteNumber) : ""
            }`}
          >
            {!loadedQuote && (
              <NoData
                loadingText="quote"
                type="quote"
                loading={true}
                showBtn={false}
              />
            )}

            {loadedQuote && (
              <div className="mainOrderPageContainer">
                <div className="mainOrderTitleWrapper">
                  <h2 className="createOrderNavbarMenuTitle">
                  {quoteInfo.sample ? <span className="text-[#9A9FA7]">Sample</span> : ""} Quote #{(quoteInfo.quoteNumber)}
                  </h2>
                  <div className="mainOrderStatusWrap">
                    {showStatusHoverBox ? (
                      <div className="mainOrderStatusHover">
                        <p className="title">
                          Status: {QUOTESTATUS[quoteInfo.status][0]}
                        </p>
                        <p className="subTitle">{QUOTESTATUS[quoteInfo.status][2]}.</p>
                      </div>
                    ) : null}
                    <div
                      className="mainOrderOrderStatus accOrderStatus"
                      style={{
                        backgroundColor: QUOTESTATUS[quoteInfo.status]
                          ? QUOTESTATUS[quoteInfo.status][1]
                          : "",
                      }}
                      onMouseOver={() => setShowStatusHoverBox(true)}
                      onMouseLeave={() => setShowStatusHoverBox(false)}
                    >
                      {QUOTESTATUS[quoteInfo.status]
                        ? QUOTESTATUS[quoteInfo.status][0]
                        : quoteInfo.status}
                      <Info className="statusIcon" />
                    </div>
                    {quoteInfo.orderID && quoteInfo.status === "ordered" && (
                      <div
                        className=" sm:block hidden mainOrderOrderStatus bg-white cursor-pointer"
                        onClick={(e) => {
                          transitionTo(
                            `/account/order/${quoteInfo.orderID}`,
                            e
                          );
                        }}
                      >
                        Go to The Order
                      </div>
                    )}
                  </div>
                </div>
                {quoteInfo.orderID && quoteInfo.status === "ordered" && (
                  <div
                    className=" sm:hidden block w-full text-center mainOrderOrderStatus bg-white cursor-pointer"
                    onClick={(e) => {
                      transitionTo(`/account/order/${quoteInfo.orderID}`, e);
                    }}
                  >
                    Go to The Order
                  </div>
                )}
                <div className="mainOrderSecondaryContent mainOrderTransBtnWrap">
                  <div
                    className=" sm:block hidden mainOrderOrderStatus bg-white cursor-pointer"
                    onClick={() => handleDownloadSummary()}
                  >
                    Download Quote
                  </div>
                </div>
              </div>
            )}

            {loadedQuote && (
              <div className="mainOrderPageContainer">
                <div className="mainOrderPageContainerOptions">
                  <div id="mainPrimary" className="mainOrderPrimaryContent">
                    <div className="accountSettingsMenu mainOrderTabMenu grid-cols-3 ">
                      <div
                        className="accountSettingsMenuTab"
                        onClick={() => setSelectedTab(0)}
                      >
                        <div className="accountSettingMenuTextWrap">
                          <p
                            className={`accountSettingMenuText ${
                              selectedTab === 0 && "selectedTab"
                            }`}
                          >
                            Quote Info
                          </p>
                        </div>
                        <div className="accountSettingsMenuSpacer">
                          <div></div>
                        </div>
                      </div>
                      <div
                        className="accountSettingsMenuTab"
                        onClick={() => setSelectedTab(1)}
                      >
                        <div className="accountSettingMenuTextWrap">
                          <p
                            className={`accountSettingMenuText ${
                              selectedTab === 1 && "selectedTab"
                            }`}
                          >
                            Files
                          </p>
                        </div>
                        <div className="accountSettingsMenuSpacer">
                          <div></div>
                        </div>
                      </div>
                      <div
                        className="accountSettingsMenuTab"
                        onClick={() => (!userData ? setIsModalOpen(true) : setSelectedTab(2))}
                      >
                        <div className="accountSettingMenuTextWrap">
                          <p
                            className={`accountSettingMenuText ${
                              selectedTab === 2 && "selectedTab"
                            }`}
                          >
                            General Chat
                          </p>
                          {selectedTab !== 2 && <MessageDot chatId={quoteInfo.generalChatId}/>}
                        </div>
                      </div>
                    </div>

                    {selectedTab === 0 && (
                      <div className="quotePrimaryOptionsWrapper accSingleQuoteDataWrapper">
                        <div className="accSingleQuoteDataWrap">
                          <div className="accSingleQuoteDataContainer">
                            <h6 className="accSingleQuoteTitle">Quote Info</h6>
                            <p className="accSingleInvoiceText accSingleInvoiceSubText">
                              Date
                            </p>
                            <p className="accSingleInvoiceText">
                              {formatDate(quoteInfo.timestamp)}
                            </p>
                          </div>
                          <div className="accSingleQuoteDataContainer">
                            <p></p>
                            <p className="accSingleInvoiceText accSingleInvoiceSubText">
                              Language
                            </p>
                            <p className="accSingleInvoiceText">
                              {getLanguage(quoteInfo.languageFrom)} to{" "}
                              {getLanguage(quoteInfo.languageTo)}
                            </p>
                          </div>
                        </div>
                        <div className="accSingleQuoteDataWrap">
                          <div className="accSingleQuoteDataContainer">
                            <h6 className="accSingleQuoteTitle">Contact</h6>
                            <p className="accSingleInvoiceText accSingleInvoiceSubText">
                              Name
                            </p>
                            <p className="accSingleInvoiceText capital">
                              {quoteInfo.name}
                            </p>
                          </div>
                          <div className="accSingleQuoteDataContainer">
                            <p></p>
                            <p className="accSingleInvoiceText accSingleInvoiceSubText">
                              Email
                            </p>
                            <p className="accSingleInvoiceText">
                              {quoteInfo.email}
                            </p>
                          </div>
                        </div>
                        <div className="accSingleQuoteDataWrap">
                          <div className="accSingleQuoteDataContainer">
                            <h6 className="accSingleQuoteTitle">Services</h6>

                            {quoteInfo.expedited || quoteInfo.expeditedPlus ? (
                              <>
                                <p className="accSingleInvoiceText accSingleInvoiceSubText">
                                  {quoteInfo.expeditedPlus
                                    ? "Expedited+"
                                    : "Expedited"}{" "}
                                  Turnaround
                                </p>
                                <p className="accSingleInvoiceText">
                                  <CHECK />
                                </p>
                              </>
                            ) : quoteInfo.notarization ? (
                              <>
                                <p className="accSingleInvoiceText accSingleInvoiceSubText">
                                  Notarization
                                </p>
                                <p className="accSingleInvoiceText">
                                  <CHECK />
                                </p>
                              </>
                            ) : quoteInfo.hardCopy ? (
                              <>
                                <p className="accSingleInvoiceText accSingleInvoiceSubText">
                                  Mail Hard Copy
                                </p>
                                <p className="accSingleInvoiceText capital">
                                {getFullAddress(quoteInfo.hardCopyExtra)}<br/><span className="font-[600]">{quoteInfo.hardCopyExtra.method ? " (USPS " + quoteInfo.hardCopyExtra.method + (quoteInfo.hardCopyExtra.requireSignature ? " - required signature" :"") + ")" : ""}</span>

                                </p>
                              </>
                            ) : (
                              <>
                                <p className="accSingleInvoiceText accSingleInvoiceSubText">
                                  No Additional Services Available
                                </p>
                              </>
                            )}
                          </div>

                          {quoteInfo.expeditedPlus &&
                            (quoteInfo.notarization || quoteInfo.hardCopy) && (
                              <div className="accSingleQuoteDataContainer">
                                <p></p>
                                <p className="accSingleInvoiceText accSingleInvoiceSubText">
                                  Expedited+ Turnaround
                                </p>
                                <p className="accSingleInvoiceText">
                                  <CHECK />
                                </p>
                              </div>
                            )}

                          {quoteInfo.notarization &&
                            (quoteInfo.expedited ||
                              quoteInfo.expeditedPlus) && (
                              <div className="accSingleQuoteDataContainer">
                                <p></p>
                                <p className="accSingleInvoiceText accSingleInvoiceSubText">
                                  Notarization
                                </p>
                                <p className="accSingleInvoiceText">
                                  <CHECK />
                                </p>
                              </div>
                            )}

                          {quoteInfo.hardCopy &&
                            (quoteInfo.expedited ||
                              quoteInfo.expeditedPlus ||
                              quoteInfo.notarization) && (
                              <div className="accSingleQuoteDataContainer">
                                <p></p>
                                <p className="accSingleInvoiceText accSingleInvoiceSubText">
                                  Mail Hard Copy
                                </p>
                                <p className="accSingleInvoiceText capital">
                                {getFullAddress(quoteInfo.hardCopyExtra)}<br/><span className="font-[600]">{quoteInfo.hardCopyExtra.method ? " (USPS " + quoteInfo.hardCopyExtra.method + (quoteInfo.hardCopyExtra.requireSignature ? " - required signature" :"") + ")" : ""}</span>

                                </p>
                              </div>
                            )}
                        </div>
                      </div>
                    )}

                    {selectedTab === 1 && (
                      <div className="quotePrimaryOptionsWrapper">
                        <h4 className="quotePrimaryTitle">Source Files</h4>
                        <div className="accSingleQuoteFileWrap">
                          {quoteInfo.files.map((file, index) => (
                            <>
                              <div
                                key={index}
                                className="fileUploaderLineOuter"
                              >
                                <div className="fileUploaderLine lg:flex-row flex-col">
                                  <div className="fileUploaderLineInfo">
                                    <GetFileTypeElement file={file}/>
                                    <p
                                      className="fileUploaderLineName"
                                    >
                                      {file.name}
                                    </p>
                                  </div>

                                  <div className="flex lg:gap-4 lg:justify-end justify-around items-center">
                                    {/* {file.status !== "uploading" &&
                                      file.timestamp && (
                                        <p className="fileUploaderLineSize max-sm:hidden">
                                          {formatDate(file.timestamp)}
                                        </p>
                                      )}
                                    {
                                      <div
                                        className="commentBtn"
                                        onClick={() => {
                                          setAddCommentFile(file);
                                        }}
                                      >
                                        Add comment
                                      </div>
                                    } */}

                                    {file.status === "uploading" ? (
                                      <div className="fileUploaderLineProgressContainer">
                                        <animated.div
                                          style={{
                                            width: `${file.progress}%`,
                                          }}
                                          className="fileUploaderLineProgress"
                                        />
                                      </div>
                                    ) : null}
                                    <DOWNLOAD
                                      className="fileUploaderLineIcon"
                                      onClick={() => {
                                        downloadFile(file.url);
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                              {quoteInfo.files.length - 1 !== index && (
                                <div className="accSingleQuoteFileDivider"></div>
                              )}
                            </>
                          ))}
                        </div>
                      </div>
                    )}

                     {selectedTab === 0 && quoteInfo.teamId && (!userData ? quoteInfo.clientFirstName : true)  && (
                        <div className="quotePrimaryOptionsWrapper">
                          <h4 className="quotePrimaryTitle">Your Client</h4>
                          <h6 className="accSingleInvoiceText accSingleInvoiceSubText">
                            If submitted, the client field will be included in
                            emails, in translations, and in your invoice.
                          </h6> 

                          <div className="accSingleOrderCCEmailWrap">
                            <FormTextInput
                              placeholder="Client First Name"
                              value={clientFirstName}
                              onChange={setClientFirstName}
                              onKeyDown={(e) =>
                                e.key === "Enter" &&
                                handleSaveClientName()
                              }
                              disabled={!(userData && (( userData.teamId && quoteInfo.teamId && userData.teamId === quoteInfo.teamId) || userData.role !== "client"))}
                            />
                            <FormTextInput
                              placeholder="Client Last Name"
                              value={clientLastName}
                              onChange={setClientLastName}
                              onKeyDown={(e) =>
                                e.key === "Enter" &&
                                handleSaveClientName()
                              }
                              disabled={!(userData && (( userData.teamId && quoteInfo.teamId && userData.teamId === quoteInfo.teamId) || userData.role !== "client"))}
                            />
                            <NewButton
                              width="86px"
                              text={saveClientBtnTxt}
                              back
                              whiteBtn
                              icon={false}
                              onClick={() => {
                                handleSaveClientName();
                              }}
                              disabled={
                                clientFirstName === "" ||
                                saveClientBtnTxt === "Saving.." || 
                                !(userData && (( userData.teamId && quoteInfo.teamId && userData.teamId === quoteInfo.teamId) || userData.role !== "client"))
                              }
                            />
                          </div>
                        </div>
                      )}

                    {selectedTab === 2 && (
                      <div className="quotePrimaryOptionsWrapper">
                        <OrderChatBox
                          type="quote"
                          userId={userData.id}
                          userRole={userData.role}
                          orderChatId={quoteInfo.generalChatId || null}
                          orderData={quoteInfo}
                          userData={userData}
                        />
                      </div>
                    )}
                  </div>

                  {selectedTab === 0 && quoteInfo.notes && (
                    <div className="quotePrimaryOptionsWrapper">
                      <h4 className="quotePrimaryTitle">General Notes</h4>
                      {quoteInfo.notes && quoteInfo.notes.blocks ? (
                        editorState.getCurrentContent().getPlainText() !==
                          "" && (
                          <div className="singleTranslationNotesContainer">
                            <div className="singleTranslationRichTextEditor no-scrollbar">
                              <Editor
                                editorState={editorState}
                                onChange={(editorState) =>
                                  setEditorState(editorState)
                                }
                                readOnly
                              />
                            </div>
                          </div>
                        )
                      ) : (
                        <p className="accSingleInvoiceText">
                          {quoteInfo.notes}
                        </p>
                      )}
                    </div>
                  )}
                </div>

                <div className="mainOrderSecondaryContent">
                  <div className="mainOrderSecondaryContentWrap">
                    {quoteInfo &&
                    (quoteInfo.status === "replied" ||
                      quoteInfo.status === "ordered" ||
                      (quoteInfo.pagesCount && quoteInfo.pagesCount !== 0)) ? (
                      <div style={{ marginTop: "1rem" }}>
                        <OrderSummary
                          order={quoteInfo}
                          certified={quoteInfo.certified}
                          pagesCount={quoteInfo.pagesCount}
                          languageFrom={quoteInfo.languageFrom}
                          languageTo={quoteInfo.languageTo}
                          discount={quoteInfo.discount}
                          showBtn={quoteInfo.status === "replied"}
                          handleBtnSubmit={() => {
                            handlePay(quoteInfo);
                          }}
                          disableBtn={false}
                          btnText={userData && teamData ? "Place Order" : "Pay"}
                          sendPaymentLinkBtn={
                            signedIn &&
                            userData &&
                            quoteInfo &&
                            quoteInfo.status === "replied" &&
                            !teamData
                          }
                          onClickPaymentLink={() => {
                            setSelectedSendPayment(quoteInfo);
                          }}
                          showFreeOrdersLeft={true}
                        />
                      </div>
                    ) : (
                      <div
                        className="orderSummary"
                        style={{ marginTop: "1rem" }}
                      >
                        <h2 className="orderSummaryTitle">SUMMARY</h2>
                        <div className="orderSummaryInfoWrapper">
                          <div className="orderSummaryInfo">
                            <p className="orderSummaryInfoCount">
                              We are currently calculating your quota. As soon
                              as we are done, you will receive an email
                              notification and will be able to see the quota
                              amount on this page
                            </p>
                          </div>
                        </div>
                      </div>
                    )}
                    <SecureAndPrivate />
                  </div>
                </div>
              </div>
            )}
          </AccountNavBar>
        </>
      )}
    </>
  );
};

export default SingleQuote;
